export default {
  subscription: {
    manage: "Gérer l'abonnement",
    page_title: "Gestion de l'abonnement",
    page_subtitle:
      "Gérez vos paramètres d'abonnement et vos préférences de renouvellement automatique",
    current_subscription: "Abonnement actuel",
    plan: "Plan",
    billing_cycle: "Cycle de facturation",
    status: "Statut",
    subscription_control: "Contrôle de l'abonnement",
    auto_renew_cancelled:
      "Le renouvellement automatique a été annulé et le service s'arrêtera après l'expiration le {date}.",
    cancel_effect:
      "L'annulation de votre abonnement prendra effet après la fin du cycle de facturation en cours. Votre abonnement restera actif jusqu'au {date}.",
    restore_prompt:
      "Votre abonnement a été annulé ou sera annulé après la fin du cycle de facturation en cours. Pour continuer à utiliser nos services, veuillez restaurer votre abonnement.",
    cancel_processing:
      "Votre demande d'annulation d'abonnement est en cours de traitement et prendra effet après la fin du cycle de facturation en cours.",
    restore_processing: "Votre demande de restauration d'abonnement est en cours de traitement.",
    expired_desc:
      "Votre abonnement a expiré. Veuillez mettre à jour vos informations de paiement pour restaurer le service.",
    paused:
      "Votre abonnement est actuellement suspendu. Les opérations d'annulation ou de restauration ne sont pas disponibles.",
    trialing:
      "Vous êtes actuellement en période d'essai. L'abonnement se convertira automatiquement en abonnement payant après la fin de la période d'essai.",
    no_action: "Le statut actuel de votre abonnement ne prend en charge aucune opération.",
    cancel_subscription_btn: "Annuler l'abonnement",
    restore_subscription_btn: "Restaurer l'abonnement",
    restoring: "Restauration en cours...",
    cancelling: "Annulation en cours...",
    status_unavailable: "Statut indisponible",
    no_active_subscription: "Vous n'avez pas d'abonnement actif",
    choose_plan: "Choisir un plan",
    cancel_modal_title: "Annuler l'abonnement",
    cancel_confirm:
      "Êtes-vous sûr de vouloir annuler votre abonnement ? Cela prendra effet après la fin du cycle de facturation en cours ({date}). Après cela, votre abonnement sera désactivé et vous perdrez l'accès aux fonctionnalités premium.",
    reason_label: "Raison (Facultatif) :",
    reason_placeholder: "Veuillez nous indiquer pourquoi vous annulez...",
    status_updated: "Statut de l'abonnement mis à jour",
    cancel_request_submitted: "Demande d'annulation d'abonnement soumise",
    cancel_failed: "Échec de l'annulation de l'abonnement",
    restore_request_submitted: "Demande de restauration d'abonnement soumise",
    restore_failed: "Échec de la restauration de l'abonnement",
    active: "Actif",
    canceled: "Annulé",
    cancel_pending: "Annulation en attente",
    restore_pending: "Restauration en attente",
    past_due: "Impayé",
    paused_status: "Suspendu",
    trialing_status: "Essai",
    next_cycle_cancel: "Annulation au prochain cycle",
    unknown_status: "Statut inconnu",
    monthly: "Mensuel",
    yearly: "Annuel",
  },
  invoices: {
    recent: "Factures récentes",
    number: "Numéro de facture",
    order_no: "N° de commande",
    amount: "Montant",
    status: "Statut",
    created_at: "Créé le",
    actions: "Actions",
    status_issued: "Émise",
    status_paid: "Payée",
    status_voided: "Annulée",
    view_all: "Voir toutes les factures",
  },
  orders: {
    no: "N° de commande",
    plan_type: "Type de plan",
    duration: "Durée",
    amount: "Montant",
    status: "Statut",
    paid_at: "Payé le",
    created_at: "Créé le",
    actions: "Actions",
    quantity: "Quantité",
    status_pending: "En attente",
    status_paid: "Payé",
    status_failed: "Échoué",
    status_refunded: "Remboursé",
    refund_pending: "Remboursement en attente",
    refund_failed: "Échec du remboursement",
    cancelled: "Annulé",
    expired: "Expiré",
    days: "Jours",
    cancel_confirm: "Êtes-vous sûr de vouloir annuler cette commande ?",
    delete_confirm: "Êtes-vous sûr de vouloir supprimer cette commande ?",
    downloading_invoice: "Téléchargement de la facture...",
    download_failed: "Échec du téléchargement",
    check_refund: "Vérification de l'éligibilité au remboursement...",
    refund_not_eligible: "Non éligible au remboursement",
    check_refund_failed: "Échec de la vérification de l'éligibilité au remboursement",
    prorated_refund_title: "Remboursement au prorata",
    prorated_refund_content:
      "Ce remboursement sera calculé au prorata en fonction de votre utilisation.",
    credits_refund_content:
      "Ce remboursement sera calculé au prorata en fonction des crédits restants.",
    full_refund_title: "Remboursement intégral",
    full_refund_content: "Vous êtes éligible à un remboursement intégral.",
    request_refund: "Demander un remboursement",
    processing_refund: "Traitement de la demande de remboursement...",
    refund_request_failed: "Échec de la demande de remboursement",
    refund_reason: "Raison du remboursement",
    refund_reason_placeholder: "Veuillez fournir une raison pour le remboursement...",
    refund_reason_required: "La raison du remboursement est requise",
    refund_conditions: "Conditions de remboursement",
    no_report_generated: "Aucun rapport généré",
    no_calculations_performed: "Aucun calcul effectué",
    no_api_used: "Aucune API utilisée",
    subscription_period: "Période d'abonnement",
    subscription_details: "Détails de l'abonnement",
    total_days: "Nombre total de jours",
    remaining_days: "Jours restants",
    refund_amount: "Montant du remboursement",
    refund_reasons: {
      order_not_found: "Commande introuvable",
      unauthorized: "Accès non autorisé",
      order_not_completed: "Seules les commandes complétées peuvent être remboursées",
      subscription_not_found: "Abonnement introuvable",
      paid_features_used:
        "Des fonctionnalités payantes ont été utilisées pendant la période d'abonnement",
      internal_error:
        "Une erreur interne s'est produite lors de la vérification de l'éligibilité au remboursement",
    },
    calculation_quota: "crédits de calcul",
    report_quota: "crédits de rapport",
    quota_info: "{purchased} {type} achetés, {used} utilisés, {remaining} restants",
    quota_detail: "{purchased} achetés, {used} utilisés, {remaining} restants",
    no_credits_used: "Aucun crédit utilisé",
    refund_requested: "Demande de remboursement soumise avec succès",
    refund_pending_approval:
      "Demande de remboursement soumise. Le remboursement est en attente d'approbation et peut prendre un certain temps à être traité.",
    refund_approved: "Remboursement approuvé avec succès",
    refund_rejected: "La demande de remboursement a été rejetée",
    refund_success: "Remboursement réussi",
    refund_processing: "Remboursement en cours de traitement",
    refund_success_message:
      "Nous avons traité votre remboursement avec succès. Cela peut prendre jusqu'à 5 jours pour que les fonds apparaissent sur votre relevé.",
    refund_processing_message:
      "Votre remboursement est encore en cours de traitement, veuillez patienter.",
    checking_order_status: "Vérification du statut de la commande...",
  },
};
